/** saves exchange table list - https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_internetexchangetable
@payload { object }
*/
export const SAVE_EXCHANGE_TABLE_LIST = (state, payload) => {
    if (payload.exchangeTableEntryViewList) {
        state.exchangeTableList = payload.exchangeTableEntryViewList
        state.lastUpdateDate = payload.lastUpdateDate
    } else {
        state.exchangeTableList = []
        state.lastUpdateDate = null
    }
}

/** saves exchange table with value - https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_internetexchangetablewithvalue
@payload { object }
*/
export const SAVE_EXCHANGE_TABLE_WITH_VALUE = (state, payload) => {
    if (payload.exchangeTableEntryViewList) {
        state.exchangeTableWithValue = payload.exchangeTableEntryViewList
        state.lastUpdateDate = payload.lastUpdateDate
    } else {
        state.exchangeTableWithValue = []
        state.lastUpdateDate = null
    }
}
